import { render, staticRenderFns } from "./CommissionPercentage.vue?vue&type=template&id=432524e0&"
import script from "./CommissionPercentage.vue?vue&type=script&lang=ts&"
export * from "./CommissionPercentage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports